import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import styled from "styled-components";

const drawerWidth = "336px";
const drawerWidthMobile = "100vw";

const StyledDrawer = styled(MuiDrawer).withConfig({
  shouldForwardProp: (prop) => prop !== "open",
})<{ open: false }>`
  width: ${(p) => {
    return p.open ? drawerWidth : `88px`;
  }};
  flexshrink: 0;
  whitespace: "nowrap";
  boxsizing: "border-box";
  transition: 400ms;

  @media (max-width: 1000px) {
    width: ${(p) => {
      return p.open ? drawerWidthMobile : `88px`;
    }};
  }
`;

const Drawer = ({ isOpenMenu, setIsOpenMenu }: any) => {
  const handleDrawerClose = () => {
    setIsOpenMenu(!isOpenMenu);
  };

  return (
    <StyledDrawer variant="permanent" open={isOpenMenu}>
      <List sx={{ minWidth: "88px" }}>
        {["Курсы", "Взаимодействие со студентами", "Успеваемость"].map(
          (text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: isOpenMenu ? "initial" : "center",
                  px: 2.5,
                }}>
                <ListItemIcon
                  sx={{
                    justifyContent: "center",
                    color: "#011224",
                  }}>
                  {index === 0 && (
                    <DomainVerificationIcon sx={{ fontSize: 20 }} />
                  )}
                  {index === 1 && (
                    <QuestionAnswerOutlinedIcon sx={{ fontSize: 20 }} />
                  )}
                  {index === 2 && (
                    <LeaderboardOutlinedIcon sx={{ fontSize: 20 }} />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  sx={{
                    display: isOpenMenu ? "block" : "none",
                    color: "#011224",
                    span: { fontWeight: 800, fontSize: "14px" },
                  }}
                />
              </ListItemButton>
            </ListItem>
          )
        )}
      </List>

      <div className="drawer-footer">
        <IconButton
          disableRipple
          size="small"
          sx={{
            color: "#808992",
            span: { fontWeight: 600, fontSize: "16px", lineHeight: "24px" },
          }}
          onClick={handleDrawerClose}>
          {!isOpenMenu ? <ChevronRight /> : <ChevronLeft />}
          <span style={{ display: isOpenMenu ? "block" : "none" }}>
            Свернуть
          </span>
        </IconButton>
      </div>
    </StyledDrawer>
  );
};
export default Drawer;
